
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MissionHero from './components/MissionHero';
import MissionContent from './components/MissionContent';
import MissionValues from './components/MissionValues';

const MissionPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <MissionHero />
        <MissionContent />
        <MissionValues />
      </main>
      <Footer />
    </div>
  );
};

export default MissionPage;
